import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';
import { LogOut as LogOutIcon } from 'lucide-react';
import { IconButton } from '@mui/material';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
    borderRight: '1px solid rgba(255, 255, 255, 0.1)',
    backgroundColor: '#0f0f0f',
    color: '#ffffff',
  },
});

interface SideMenuProps {
  currentView: string;
  onViewChange: (view: string) => void;
  user: {
    name: string;
    email: string;
    role: string;
    avatar?: string;
  };
  getUserInitials: () => string;
  onLogout: () => void;
}

export default function SideMenu({ currentView, onViewChange, user, getUserInitials, onLogout }: SideMenuProps) {
  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontSize: '1.1rem', fontWeight: 700, color: '#ffffff' }}>
          Project Manager
        </Typography>
      </Box>
      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)' }} />
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MenuContent currentView={currentView} onViewChange={onViewChange} />
      </Box>
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <Avatar
          sizes="small"
          alt={user.name}
          src={user.avatar}
          sx={{ width: 36, height: 36, bgcolor: 'hsl(45, 90%, 35%)', color: 'white' }}
        >
          {!user.avatar && getUserInitials()}
        </Avatar>
        <Box sx={{ mr: 'auto', overflow: 'hidden' }}>
          <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: '16px', color: '#ffffff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user.name}
          </Typography>
          <Typography variant="caption" sx={{ color: '#aaaaaa', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
            {user.email}
          </Typography>
        </Box>
        <IconButton size="small" onClick={onLogout} title="Logout" sx={{ color: '#ffffff' }}>
          <LogOutIcon size={18} />
        </IconButton>
      </Stack>
    </Drawer>
  );
}
